<div class="col-lg-2 col-md-3 col-6 col-sm-4">
  <a [href]="partner.url" target="_blank">
    <img [src]="partner.bwImage" alt="partner" />
    <img [src]="partner.cImage" alt="partner" />
  </a>
</div>
